export default __webpack_public_path__ + "static/media/analytics_3.8e58a4ea.svg";